import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { MenuBar, Icon, Button } from 'Components';
import menuOptions from 'constants/menuOptions';
import rowRules from 'helpers/rowRules';
import './InvoicesListMobileItemBody.css';

const InvoicesListMobileItemBody = ({
  data,
  setInvoiceMobileState,
  onMenuClick,
  index,
}) => (
  <div className="invoices-list-mobile-item-body">
    <div className="invoices-list-mobile-item-body__menu-bar">
      <MenuBar
        onClick={onMenuClick}
        tableIndex={index}
        icons={menuOptions.filter(option => rowRules.invoice(option, data))}
        show
      />
    </div>
    <span className="invoices-list-mobile-item-body__title">{i18n.t('invoices:Job #')}</span>
    {
      data.Jobs.map((job, i) => (
        <Button
          onClick={() => setInvoiceMobileState({
            selectedInvoiceNumber: data.InvoiceNumber,
            selectedJob: data.Jobs[i],
          })}
          key={job.MaxxamJobNumber}
          className="invoices-list-mobile-item-body__link"
        >
          <span>{job.MaxxamJobNumber}</span>
          <Icon icon="chevron_right" />
        </Button>
    ))
    }
  </div>
);

InvoicesListMobileItemBody.propTypes = {
  data: PropTypes.shape({}),
  setInvoiceMobileState: PropTypes.func,
  onMenuClick: PropTypes.func,
  index: PropTypes.number,
};
export default InvoicesListMobileItemBody;



// WEBPACK FOOTER //
// ./src/containers/Invoices/InvoicesList/InvoicesListMobile/InvoicesListMobileItemBody/InvoicesListMobileItemBody.jsx